import React from "react";
import "../styles/footer.css";
import logo from "../assets/images/logo.png";

const Footer = () => {
  return (
    <footer className="footer-section">

      <div className="container">

        <div className="footer-wrapper">

          {/* Left Social */}

          <div className="footer-social">

            <a
              href="https://t.me/skyterminal_news"
              target="_blank"
              rel="noreferrer"
              className="footer-icon"
            >
              <i className="fa-solid fa-paper-plane"></i>
            </a>

            <a
              href="https://x.com/skyterminal_io"
              target="_blank"
              rel="noreferrer"
              className="footer-icon"
            >
              <i className="fa-brands fa-x-twitter"></i>
            </a>

            <a
              href="https://medium.com/@skyterminal"
              target="_blank"
              rel="noreferrer"
              className="footer-icon"
            >
              <i className="fa-brands fa-medium-m"></i>
            </a>

          </div>

          {/* Center Logo */}

          <div className="footer-center">

            <img
              src={logo}
              alt="Sky Terminal"
              className="footer-logo"
            />

            <p>
              © 2026 Sky Terminal. All rights reserved.
            </p>

          </div>

          {/* Right Buttons */}

          <div className="footer-buttons">

            <a
              href="https://skyterminal.gitbook.io/docs" target="_blank" rel="noreferrer"
              className="footer-btn"
            >
              WHITEPAPER
            </a>

            <a
              href="mailto:term@skyterminal.io"
              className="footer-btn"
            >
              CONTACT
            </a>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;